import * as React from "react";
import axios from "axios";
import { Alert, Snackbar } from "@mui/material";
import { SERVER_URL } from "../../config/config";

// Indian Locations
const indiaLocations = [
  {
    id: "pune",
    city: "Pune",
    company: "Nirantara Ecoventures Pvt Ltd",
    address:
      "Office no. 405, 4th Floor, Tower 2, World Trade Center, Kharadi, Pune – 411014, Maharashtra, India",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15129.848247800468!2d73.93068813955078!3d18.553195999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526680d41c1613%3A0x7cd2884676ebaaeb!2sNirantara%20Ecoventures%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1763619540337!5m2!1sen!2sin",
    directionsUrl: "https://maps.app.goo.gl/pune",
  },
  {
    id: "chennai",
    city: "Chennai",
    company: "Nirantara Ecoventures Pvt Ltd",
    address:
      "New No.16 Old No.18, Chengalvarayan Street, Shenoy Nagar, Egmore Nungambakkam, Chennai- 600030, Tamil Nadu, India",
    mapUrl:
      "https://www.google.com/maps?q=13.0752351,80.22963&z=15&output=embed",
    directionsUrl: "https://maps.app.goo.gl/jjZpAS5Xf6doKhgz8",
  },
  {
    id: "kolhapur",
    city: "Kolhapur",
    company: "Nirantara Ecoventures Pvt Ltd",
    address:
      "4th Floor, Kailash Tower, Assembly Road, Station Road Corner, New Shahupuri, Kolhapur, Maharashtra 416001",
    mapUrl:
      "https://www.google.com/maps?q=16.7031298,74.2340117&z=16&output=embed",
    directionsUrl: "https://maps.app.goo.gl/4hPxgYupAzvTHLkG9",
  },
  {
    id: "aurangabad",
    city: "Chh. Sambhaji Nagar",
    company: "Nirantara Ecoventures Pvt Ltd",
    address:
      "CMIA, Bajaj Bhawan, P-2, MIDC Station Road, Aurangabad - 431005, Maharashtra",
    mapUrl:
      "https://www.google.com/maps?q=19.8595683,75.3170451&z=17&output=embed",
    directionsUrl: "https://maps.app.goo.gl/rwYBkPuCuSVPigqe8",
  },
  {
    id: "nashik",
    city: "Nashik",
    company: "Nirantara Ecoventures Pvt Ltd",
    address:
      "Office NO- 306, Business Center, New Ring Road, Radha Vasudev Batavia Nagar, Govind Nagar, Nashik, Maharashtra 422009",
    mapUrl:
      "https://www.google.com/maps?q=19.9845321,73.7747878&z=15&output=embed",
    directionsUrl: "https://maps.app.goo.gl/n8cFk3KDLDSVCD62A",
  },
  {
    id: "bhubaneswar",
    city: "Bhubaneswar",
    company: "Nirantara Ecoventures Pvt Ltd",
    address:
      "Hall No. E/5, 5th Floor, Metro House, Plot No. A/410, Saheed Nagar, Bhubaneswar – 751007",
    mapUrl:
      "https://www.google.com/maps?q=20.2937355,85.8521901&z=18&output=embed",
    directionsUrl: "https://maps.app.goo.gl/gkXktHuAJ4QkA4dK8",
  },
  {
    id: "ludhiana",
    city: "Ludhiana",
    company: "Nirantara Ecoventures Pvt Ltd",
    address:
      "2nd Floor, SCO 3, Above Union Bank of India, Urban Estate, Phase-2, Focal Point, Ludhiana, Punjab – 141010",
    mapUrl:
      "https://www.google.com/maps?q=30.8918437,75.9166981&z=15&output=embed",
    directionsUrl: "https://maps.app.goo.gl/YHeQw3phPAa5EkQT8",
  },
  {
    id: "ncr",
    city: "NCR",
    company: "Nirantara Ecoventures Pvt Ltd",
    address:
      "C/O Safeline Water Lines Pvt Ltd A-915, Tower A Front Side C28 29, Logix Cyber Park, C block Industrial Area Phase-2 Sector 62, Noida, UP-201309",
    mapUrl:
      "https://www.google.com/maps?q=28.6126141,77.3655051&z=13&output=embed",
    directionsUrl: "https://maps.app.goo.gl/YyPUR8otzU1di4ER6",
  },
];

// Foreign Locations
const globalLocations = [
  {
    id: "uae",
    country: "UAE",
    company: "Nirantara Sustainable Consultancy LLC",
    address:
      "1513, Grosvenor Business Tower, Al Barsha Heights, Dubai, P.O.Box 454352 United Arab Emirates",
    mapUrl:
      "https://www.google.com/maps?q=25.0989494,55.1773638&z=17&output=embed",
    directionsUrl: "https://maps.app.goo.gl/NouC6Q1DrSYQUKxZ7",
  },
  {
    id: "singapore",
    country: "Singapore",
    company: "Nirantara Sustainable Ventures Pte Ltd",
    address: "36 Robinson Road # 20-01 City House Singapore 068877",
    mapUrl:
      "https://www.google.com/maps?q=1.2826904,103.8498285&z=17&output=embed",
    directionsUrl: "https://maps.app.goo.gl/WZNECJYdTpi4zxW47",
  },
  {
    id: "netherlands",
    country: "Netherlands",
    company: "Nirantara Sustainable Ventures B.V.",
    address:
      "World Trade Center Twente, Industrieplein 1, 7553 LL Hengelo, Netherlands",
    mapUrl:
      "https://www.google.com/maps?q=52.260964,6.7926439&z=17&output=embed",
    directionsUrl: "https://maps.app.goo.gl/oDR8eyujgWcdmQQh7",
  },
];

function LocationCard({ location, isSelected, onClick }) {
  // Defensive check to prevent rendering blank cards
  if (!location) {
    return null;
  }

  const displayLabel = location.city || location.country || "Location";
  const borderClass = isSelected
    ? "border-2 border-[#C2DAFF]"
    : "border border-[#C2DAFF]";

  return (
    <article
      onClick={onClick}
      className={`flex flex-col w-full p-4 text-base font-semibold leading-6 bg-[#E8F4FF] rounded-lg shadow-lg cursor-pointer transition-all hover:shadow-xl ${borderClass} max-md:px-5 max-md:mt-5 max-md:max-w-full`}
    >
      <h3 className="font-medium text-[#EB7E0E] text-sm">{displayLabel}</h3>
      <h2 className="mt-3 text-xl text-black capitalize max-md:max-w-full">
        {location.company}
      </h2>
      <p
        className="mt-2 font-normal text-sm text-black max-md:max-w-full leading-5"
        style={{
          whiteSpace: location.country === "Netherlands" ? "pre-line" : null,
        }}
      >
        {location.address}
      </p>
      <a
        href={
          location.directionsUrl || "mailto:sustainable@nirantara.solutions"
        }
        target={location.directionsUrl ? "_blank" : undefined}
        rel={location.directionsUrl ? "noopener noreferrer" : undefined}
        onClick={(e) => {
          if (onClick) {
            e.stopPropagation();
          }
        }}
        className="self-start justify-center px-4 py-2 mt-3 text-sm text-center text-white capitalize rounded-lg bg-[#1C486B] border border-[#C2DAFF] whitespace-nowrap max-md:px-5"
      >
        {location.directionsUrl ? "Get Directions →" : "Contact Branch"}
      </a>
    </article>
  );
}

function ContactForm() {
  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });
  const [errors, setErrors] = React.useState({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [submitError, setSubmitError] = React.useState("");
  const [submitSuccess, setSubmitSuccess] = React.useState(false);
  const [acceptedTerms, setAcceptedTerms] = React.useState(false);

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "name":
        if (!value.trim()) {
          error = "Full name is required";
        } else if (value.trim().length < 2 || value.trim().length > 100) {
          error = "Name must be between 2 and 100 characters";
        }
        break;
      case "email":
        if (!value.trim()) {
          error = "Email address is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = "Please provide a valid email address";
        }
        break;
      case "phone":
        if (!value.trim()) {
          error = "Phone number is required";
        } else if (
          !/^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,9}$/.test(
            value,
          )
        ) {
          error = "Please provide a valid phone number";
        }
        break;
      case "company":
        if (value.trim() && value.trim().length > 100) {
          error = "Company name must not exceed 100 characters";
        }
        break;
      case "message":
        if (value.trim() && value.trim().length > 2000) {
          error = "Message must not exceed 2000 characters";
        }
        break;
      default:
        break;
    }

    return error;
  };

  const validateForm = () => {
    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) {
        newErrors[key] = error;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate field on change and clear error
    const error = validateField(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: error || undefined,
    }));

    // Clear submit error when user starts typing
    if (submitError) setSubmitError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields before submission
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");
    setSubmitSuccess(false);

    try {
      // const apiUrl = 'http://localhost:8081';
      const response = await axios.post(
        `${SERVER_URL}/nirantara/contact/submit`,
        {
          name: formData.name.trim(),
          email: formData.email.trim(),
          phone: formData.phone.trim() || undefined,
          company: formData.company.trim() || undefined,
          message: formData.message.trim(),
        },
      );

      if (response.data.success) {
        setSubmitSuccess(true);
        setErrors({});
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          message: "",
        });
        // Clear success message after 5 seconds
        setTimeout(() => setSubmitSuccess(false), 10000);
      }
    } catch (error) {
      console.error("Contact form submission error:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.errors?.[0]?.msg ||
        "Failed to submit your message. Please try again later.";
      setSubmitError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full h-full flex flex-col">
      <Snackbar
        open={submitSuccess}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setSubmitSuccess(false)}
      >
        <Alert
          severity="success"
          variant="filled"
          onClose={() => setSubmitSuccess(false)}
          sx={{ width: "100%" }}
        >
          Thank you for contacting us! We will get back to you soon.
        </Alert>
      </Snackbar>

      <div className="p-6 bg-white border border-gray-100 shadow-md rounded-xl flex-1 flex flex-col">
        {submitSuccess && (
          <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-md">
            <p className="text-sm font-medium text-green-800">
              Thank you for contacting us! We will get back to you soon.
            </p>
          </div>
        )}
        {submitError && (
          <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-md">
            <p className="text-sm font-medium text-red-800">{submitError}</p>
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="name"
              className="block mb-2 text-sm font-semibold text-gray-700"
            >
              Full Name *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className={`w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#EB7E0E] focus:border-transparent ${errors.name ? "border-red-500" : "border-gray-300"
                }`}
              placeholder="Enter your name"
            />
            {errors.name && (
              <p className="mt-1 text-sm text-red-600">{errors.name}</p>
            )}
          </div>

          <div>
            <label
              htmlFor="email"
              className="block mb-2 text-sm font-semibold text-gray-700"
            >
              Email Address *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className={`w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#EB7E0E] focus:border-transparent ${errors.email ? "border-red-500" : "border-gray-300"
                }`}
              placeholder="your@email.com"
            />
            {errors.email && (
              <p className="mt-1 text-sm text-red-600">{errors.email}</p>
            )}
          </div>

          <div>
            <label
              htmlFor="phone"
              className="block mb-2 text-sm font-semibold text-gray-700"
            >
              Mobile Number *
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className={`w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#EB7E0E] focus:border-transparent ${errors.phone ? "border-red-500" : "border-gray-300"
                }`}
              placeholder="+1 234 567 8900"
            />
            {errors.phone && (
              <p className="mt-1 text-sm text-red-600">{errors.phone}</p>
            )}
          </div>

          <div>
            <label
              htmlFor="company"
              className="block mb-2 text-sm font-semibold text-gray-700"
            >
              Company Name
            </label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleChange}
              className={`w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#EB7E0E] focus:border-transparent ${errors.company ? "border-red-500" : "border-gray-300"
                }`}
              placeholder="Your company"
            />
            {errors.company && (
              <p className="mt-1 text-sm text-red-600">{errors.company}</p>
            )}
          </div>

          <div>
            <label
              htmlFor="message"
              className="block mb-2 text-sm font-semibold text-gray-700"
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="2"
              className={`w-full px-4 py-3 border rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-[#EB7E0E] focus:border-transparent ${errors.message ? "border-red-500" : "border-gray-300"
                }`}
              placeholder="Tell us about your inquiry..."
            />
            {errors.message && (
              <p className="mt-1 text-sm text-red-600">{errors.message}</p>
            )}
          </div>

          <div className="flex items-start gap-2 mt-2">
            <input
              type="checkbox"
              id="acceptedTerms"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
              className="mt-1 w-4 h-4 text-[#EB7E0E] bg-gray-100 border-gray-300 rounded focus:ring-[#EB7E0E] cursor-pointer"
            />
            <label htmlFor="acceptedTerms" className="text-sm text-gray-700 cursor-pointer">
              I acknowledge that I have read and agree to the <a href="/contact-us/privacy-policy.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Privacy Policy and Terms of Service.</a>
            </label>
          </div>

          <button
            type="submit"
            disabled={isSubmitting || !acceptedTerms}
            className={`w-full px-8 py-3 font-semibold text-white transition-all duration-300 rounded-lg shadow-sm bg-[#EB7E0E] hover:bg-[#EB7E0E] hover:shadow-md ${isSubmitting || !acceptedTerms ? "opacity-50 cursor-not-allowed" : ""
              }`}
          >
            {isSubmitting ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
}

function Content() {
  const [selectedRegion, setSelectedRegion] = React.useState("India");
  const [selectedLocation, setSelectedLocation] = React.useState(
    indiaLocations[0],
  );

  const regions = [
    { id: "India", label: "India", flag: "🇮🇳", locations: indiaLocations },
    { id: "UAE", label: "UAE", flag: "🇦🇪", locations: [globalLocations[0]] },
    {
      id: "Singapore",
      label: "Singapore",
      flag: "🇸🇬",
      locations: [globalLocations[1]],
    },
    {
      id: "Netherlands",
      label: "Netherlands",
      flag: "🇳🇱",
      locations: [globalLocations[2]],
    },
  ];

  const currentLocations =
    regions.find((r) => r.id === selectedRegion)?.locations || [];

  React.useEffect(() => {
    // Set first location of selected region as default
    if (currentLocations.length > 0) {
      setSelectedLocation(currentLocations[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRegion]);

  const handleLocationClick = (location) => {
    setSelectedLocation(location);
  };

  return (
    <main className="flex flex-col w-full">
      {/* Contact Us Hero Banner */}
      <section className="flex flex-col justify-center w-full text-white mb-12">
        <div className="flex overflow-hidden relative flex-col items-center px-6 md:px-8 lg:px-10 pt-6 pb-14 w-full banner_container lg:min-h-[calc(100vh-100px)] max-md:px-5 max-md:max-w-full">
          <img
            loading="lazy"
            src="/assets/images/contact/main-img.jpg"
            alt="Contact Us Background"
            style={{ filter: "brightness(50%)" }}
            className="absolute inset-0 object-cover size-full"
          />
          <h5 className="absolute font-bold text-4xl md:text-6xl text-left text-white bottom-[25%] left-[6%] md:left-[7%] lg:left-[8%] whitespace-pre-line uppercase !leading-[1.3]">
            CONTACT US
          </h5>
        </div>
      </section>

      {/* Content Container */}
      <div className="w-full max-w-[95rem] mx-auto px-6 py-12 md:px-8 lg:px-10">
        {/* Our Presence Section */}
        <section className="w-full mb-12">
          <div className="flex items-center gap-2 py-3 text-2xl font-bold md:py-6 poppins">
            <h2 className="text-blue-800">OUR PRESENCE</h2>
            <svg
              className="w-8 h-6"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="10" stroke="#1e40af" strokeWidth="2" />
              <path
                d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                stroke="#1e40af"
                strokeWidth="2"
              />
            </svg>
          </div>

          {/* Region Tabs */}
          <div className="flex gap-2 mb-6 overflow-x-auto">
            {regions.map((region) => (
              <button
                key={region.id}
                onClick={() => setSelectedRegion(region.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap ${selectedRegion === region.id
                  ? "bg-[#EB7E0E] text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
              >
                <span className="mr-2">{region.flag}</span>
                {region.label}
              </button>
            ))}
          </div>

          {/* Locations and Map Section */}
          <div className="flex w-full gap-5 md:gap-6 max-lg:flex-col">
            {/* Locations List - Left */}
            <section className="flex-1 w-full max-lg:w-full">
              <div className="flex flex-col gap-4 max-h-[600px] overflow-y-auto pr-2">
                {currentLocations.map((location) => (
                  <LocationCard
                    key={location.id}
                    location={location}
                    isSelected={selectedLocation?.id === location.id}
                    onClick={() => handleLocationClick(location)}
                  />
                ))}
              </div>
            </section>

            {/* Map - Right */}
            <section className="flex-1 w-full max-lg:w-full">
              <div className="sticky top-4 bg-white rounded-lg shadow-lg overflow-hidden">
                {selectedLocation && (
                  <iframe
                    src={selectedLocation.mapUrl}
                    width="100%"
                    height="600"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="w-full"
                  ></iframe>
                )}
              </div>
            </section>
          </div>
        </section>
      </div>

      {/* Get In Touch Section */}
      <section className="w-full mb-8 px-6 md:px-8 lg:px-10">
        <div className="max-w-[120rem] mx-auto">
          <div className="flex gap-6 items-stretch max-lg:flex-col">
            {/* Image - Left */}
            <div className="flex-[2.5] w-full max-lg:w-full flex items-stretch min-h-[600px]">
              <img
                src="/assets/images/get-in-touch.png"
                alt="Get in Touch"
                className="w-full h-full object-cover object-left rounded-lg"
                style={{ minHeight: "100%", objectPosition: "left center" }}
              />
            </div>

            {/* Form - Right */}
            <div className="flex-1 w-full max-lg:w-full flex min-h-[600px]">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Content;
